import httpClient, { handleApiResponse } from './network/httpClient';
import { APIResponse } from './types';
import { AxiosRequestConfig } from 'axios';

// Object literal instead of class/namespace
export const BaseService = {
  async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    try {
      const response = await httpClient.get<APIResponse<T>>(url, config);
      return handleApiResponse<T>(response);
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async post<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
    try {
      const response = await httpClient.post<APIResponse<T>>(url, data, config);
      return handleApiResponse<T>(response);
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async put<T>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<T> {
    try {
      const response = await httpClient.put<APIResponse<T>>(url, data, config);
      return handleApiResponse<T>(response);
    } catch (error) {
      throw this.handleError(error);
    }
  },

  async delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    try {
      const response = await httpClient.delete<APIResponse<T>>(url, config);
      return handleApiResponse<T>(response);
    } catch (error) {
      throw this.handleError(error);
    }
  },

  // Centralized error handling
  handleError(error: unknown): Error {
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);
    return new Error('Unknown error occurred');
  },
};
